import { Card } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PageHeader from "@saleor/components/PageHeader";
import { InstagramLabelList_instagramLabels_edges_node } from "@saleor/inslabel/types/InstagramLabelList";
import { InslabelListUrlSortField } from "@saleor/inslabel/urls";
import { sectionNames } from "@saleor/intl";
import { PageListProps, SortPage } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Container from "../../../components/Container";
import InslabelList from "../InslabelList";

export interface InslabelListPageProps
  extends PageListProps,
    SortPage<InslabelListUrlSortField> {
  insLabels: InstagramLabelList_instagramLabels_edges_node[];
  onDelete: (id: string) => void;
  onAdd: () => void;
  toatlCount:number;
}

const InslabelListPage: React.FC<InslabelListPageProps> = ({
  onAdd,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();
  return (
    <Container>
      <PageHeader title={intl.formatMessage(sectionNames.label)+"("+toatlCount+")"}>
        <div style={{ width: "20px" }} />
        <Button onClick={onAdd} color="primary" variant="contained">
          <FormattedMessage
            defaultMessage="Create Label"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <InslabelList {...listProps} />
      </Card>
    </Container>
  );
};

export default InslabelListPage;
